import type { ISerialize } from '@/objects/ISerialize';
import { MapPoint } from './MapPoint';
import { EstimatedPosition } from './EstimatedPosition';

export class RaceContestantPosition implements ISerialize {
    public EstimatedPoint: MapPoint | null;

    public EstimatedPosition: EstimatedPosition | null;

    public GpsPoint: MapPoint | null;

    public IsOutsideGeofence: boolean | null;

    public RaceContestantID: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        EstimatedPoint?: MapPoint | null;
        EstimatedPosition?: EstimatedPosition | null;
        GpsPoint?: MapPoint | null;
        IsOutsideGeofence?: boolean | null;
        RaceContestantID?: number;
    }) {
        this.EstimatedPoint = values.EstimatedPoint ?? null;

        this.EstimatedPosition = values.EstimatedPosition ?? null;

        this.GpsPoint = values.GpsPoint ?? null;

        this.IsOutsideGeofence = values.IsOutsideGeofence ?? null;

        this.RaceContestantID = values.RaceContestantID ?? 0;
    }

    public serialize(): string {
        return (
            '{' +
            `"EstimatedPoint": ${!this.EstimatedPoint ? null : this.EstimatedPoint?.serialize()}` +
            ',' +
            `"EstimatedPosition": ${!this.EstimatedPosition ? null : this.EstimatedPosition?.serialize()}` +
            ',' +
            `"GpsPoint": ${!this.GpsPoint ? null : this.GpsPoint?.serialize()}` +
            ',' +
            `"IsOutsideGeofence": ${JSON.stringify(this.IsOutsideGeofence)}` +
            ',' +
            `"RaceContestantID": ${JSON.stringify(this.RaceContestantID)}` +
            '}'
        );
    }

    /**
     * Creates an instance of RaceContestantPosition from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        EstimatedPoint?: MapPoint | null;
        EstimatedPosition?: EstimatedPosition | null;
        GpsPoint?: MapPoint | null;
        IsOutsideGeofence?: boolean | null;
        RaceContestantID?: number;
    }): RaceContestantPosition {
        return new RaceContestantPosition(values);
    }

    public static _FromServerJson(json: any): RaceContestantPosition {
        return new RaceContestantPosition({
            EstimatedPoint: json.EstimatedPoint ? MapPoint._FromServerJson(json.EstimatedPoint) : null,
            EstimatedPosition: json.EstimatedPosition ? EstimatedPosition._FromServerJson(json.EstimatedPosition) : null,
            GpsPoint: json.GpsPoint ? MapPoint._FromServerJson(json.GpsPoint) : null,
            IsOutsideGeofence: json.IsOutsideGeofence ?? null,
            RaceContestantID: json.RaceContestantID,
        });
    }

    /**
     * Creates an instance of RaceContestantPosition from another instance of RaceContestantPosition.
     * @param other The RaceContestantPosition you want to clone
     * @returns A cloned RaceContestantPosition
     */
    public static FromOther(other: RaceContestantPosition): RaceContestantPosition {
        return RaceContestantPosition._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return RaceContestantPosition.FromOther(this);
    }

    static NAME_OF_CLASS = 'RaceContestantPosition';
}
